exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Colors */\n/* Sizes */\n/* Breakpoints */\n/* Mobile */\n/* Fonts */\n.KioskConfigurator__kioskConfigurator___3d5CtIpL {\n  height: calc(100vh - 115px);\n  min-height: calc(1920px - 115px);\n  flex: 1 1 0;\n}\n", ""]);
// Exports
exports.locals = {
	"kioskConfigurator": "KioskConfigurator__kioskConfigurator___3d5CtIpL"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/apps/kiosk/components/KioskConfigurator.vue?vue&type=style&index=0&lang=scss&module=true&
// module id = 7HHR
// module chunks = 3